module.exports = __webpack_public_path__ + "static/media/game.ba7343e5.png";